import { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useFormikContext } from "formik";
import ZingLogo from "../../../Images/logo-Z.png";
import { useSessionStore } from "../../../Stores/SessionStore";
import SalesAgentsModal from "./SalesAgentsModal";
import AgentAlreadyAssignedModal from "./AgentAlreadyAssignedModal";

export default function SalesAgentSelect(props) {
	const store = useSessionStore();
	const formik = useFormikContext();

	const [salesAgents, setSalesAgents] = useState([]);
	const [modal, setModal] = useState({ show: false });
	const [showAgentAlreadyAssigned, setShowAgentAlreadyAssigned] = useState(false);

	useEffect(() => {
		async function loadSalesAgents() {
			const result = await store.SalesAgentsService.GetSalesAgents();
			if (result?.Success) {
				setSalesAgents(result.Data ?? []);
			}
		}
		loadSalesAgents();
	}, [store]);

	function openModal() {
		if (props.existingCustomer) {
			setShowAgentAlreadyAssigned(true);
			return;
		}
		setModal({ show: true });
	}

	function closeModal() {
		setModal({ show: false });
	}

	function handleSelected(agentId) {
		formik?.setFieldValue?.("SalesAgentId", agentId ?? "");
		setModal({ show: false });
	}

	return (
		<>
			<Col xs={3} lg={1} className="mb-3 mb-lg-0">
				<img
					src={ZingLogo}
					alt="Select sales agent"
					className="w-100"
					onClick={openModal}
				/>
			</Col>
			<SalesAgentsModal
				modal={{
					show: modal.show,
					salesAgents,
					currentId: formik?.values?.SalesAgentId ?? "",
					onSelect: handleSelected,
					onClose: closeModal,
				}}
			/>
			<AgentAlreadyAssignedModal show={showAgentAlreadyAssigned} onOKClicked={() => setShowAgentAlreadyAssigned(false)} />
		</>
	);
}
